import { render, staticRenderFns } from "./CoursewareCommentsOverviewWidgetFilterType.vue?vue&type=template&id=641af7ec&"
import script from "./CoursewareCommentsOverviewWidgetFilterType.vue?vue&type=script&lang=js&"
export * from "./CoursewareCommentsOverviewWidgetFilterType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports